import type { FaireProductEntity } from "../../entity_types/product";

export const p_7273nmn4mf: FaireProductEntity = {
  token: "p_7273nmn4mf",
  type: "product",
  name: "Miyuki Seed Bead Threader Earrings",
  brandToken: "b_69a84848",
  brandName: "Amano Studio",
  imageUrl:
    "https://cdn.faire.com/fastly/c90ba1811a72e490c47dfcf752bf1b54a16624dbd761441e94eb09d236792ec7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/55b1e161275c51941db2d295837041688c3cc58c2810d78e9d74eacc3ec604aa.jpeg",
    "https://cdn.faire.com/fastly/5ecfab64bbc721cda6125dbdf2ef949889defa4be1d340cf94c9876727ee617c.jpeg",
    "https://cdn.faire.com/fastly/49918559c3f6beee83bd882639537e5b3467f69f672cc411ce34df2329f3c086.jpeg",
    "https://cdn.faire.com/fastly/795359a3ebb0403c01813ca42fa41ad3a7429e4ae5e37a505548efa3a8a3a1e3.jpeg",
    "https://cdn.faire.com/fastly/805e2c6486053f619f4aa78a7dae95f5525f753c919addcd531d150123131835.jpeg",
    "https://cdn.faire.com/fastly/d0b40bc02425f767aae73818c9f151d0517ed57043797143887b5fcdb8e0718b.jpeg",
    "https://cdn.faire.com/fastly/c603a18dd1e383fe1c256e4dc77364f23ef4d7c5133cfe7e1758f05aea903cc2.jpeg",
    "https://cdn.faire.com/fastly/8746c6abc63277a149da668b521e6d0244473824485b49f3f87be87397034db0.jpeg",
    "https://cdn.faire.com/fastly/53c51452f221e5fee3c4531cdae9c0fcb5872fb3c1410d19ee951d5d9ac8a2cc.jpeg",
  ],
  priceDollars: 15,
  description:
    'We are very excited about these new earrings! They combine our best selling threaders with our best selling Miyuki seed bead earrings. They hang 3.25" so they are swishy and sexy. Great for summer, and elegant enough for a dressy night out. Made with genuine Japaese Miyuki beads and 14k gold plated brass.\n\nDesigned in our Sonoma California studio and made exclusively for us in Seoul South Korea.',
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:37.589Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
